import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';

export const StyledLightningLinkMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 100px;
  position: relative;
  display: flex;

  .product-img {
    min-width: 40px;
    max-width: 40px;
    display: flex;
    justify-content: center;
    position: relative;
  }

  img {
    position: absolute;
    height: 40px;
    top: calc(50% - 21px);
  }

  .text-container {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    font-family: ${(props: any) => props.fontFamily};
    min-width: 0;  

    &__stroked {
      padding-right: 5px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration: line-through;
      color: #cacaca;
    }
  }
` as any;

export const StyledQuantity = styled(Box)<{ title: string }>`
  padding-right: 5px;
  min-width: 0;
  z-index: 1;

  .quantity_text {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    background: linear-gradient(180deg, #fffbff 40%, #b196ed 60%) text;
    background-clip: text;
    -webkit-background-clip: text;
    color: #ffff;
    width: 100%;
    @supports (
      background: linear-gradient(180deg, #fffbff 40%, #b196ed 60%) text
    ) {
      -webkit-text-fill-color: transparent;
    }
    position: relative;

    &:after {
      background: none;
      content: '${({ title }) => title}';
      left: 0;
      top: 0;
      z-index: -1;
      position: absolute;
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
    }
  }

  @media (min-width: ${breakpoints.mobileL}) {
    font-size: 14px;
  }
`;

export const StyledLightningLinkSubProduct = styled.div<{isTooltipShown: boolean}>`
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  .product-info {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;  

    .product-img {
      min-width: 40px;
      max-height: 40px;
      display: flex;
      justify-content: center;
      position: relative;
    }

    .product-img img {
      height: 36px;
      width: 36px;
    }
  }

  .tooltip-icon {
    height: 24px;
  }

  .quantity_container {
    margin-right:${(props: any) => props.isTooltipShown ? '30px': 0};  
  }
` as any;
